import { lazy } from "react"

const PALayout = lazy(() =>  import("./../modules/admin/containers/layout/Layout"))

export const pa = {
  path: "/pa",
  component: PALayout
}
